import '../styles/logo.css';

// Logo « Aperture » — Kévin Gelineau
// Marque vectorielle inline : prend la couleur du texte (currentColor),
// donc elle se recolore et s'anime via CSS.
//
//   <ApertureMark />                 → symbole décoratif (masqué aux lecteurs d'écran)
//   <ApertureMark title="Accueil" /> → symbole porteur de sens, annoncé
//   <Logo withWordmark size={26} />  → symbole + « Kévin Gelineau »

export function ApertureMark({ size = 28, title, ...props }) {
  // Sans `title`, la marque est décorative : la masquer évite une annonce
  // en double quand un texte ou un aria-label la décrit déjà.
  const label = title
    ? { role: 'img', 'aria-label': title }
    : { 'aria-hidden': true, focusable: 'false' };

  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      {...label}
      {...props}
    >
      <polygon
        points="60,18 96.4,39 96.4,81 60,102 23.6,81 23.6,39"
        strokeWidth="5"
        strokeLinejoin="round"
      />
      <polygon
        points="72,39.2 84,60 72,80.8 48,80.8 36,60 48,39.2"
        strokeWidth="3"
        strokeLinejoin="round"
        opacity="0.72"
      />
      <line x1="60" y1="18" x2="72" y2="39.2" strokeWidth="2.6" strokeLinecap="round" />
      <line x1="96.4" y1="39" x2="84" y2="60" strokeWidth="2.6" strokeLinecap="round" />
      <line x1="96.4" y1="81" x2="72" y2="80.8" strokeWidth="2.6" strokeLinecap="round" />
      <line x1="60" y1="102" x2="48" y2="80.8" strokeWidth="2.6" strokeLinecap="round" />
      <line x1="23.6" y1="81" x2="36" y2="60" strokeWidth="2.6" strokeLinecap="round" />
      <line x1="23.6" y1="39" x2="48" y2="39.2" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ size = 28, withWordmark = false, className = '' }) {
  if (!withWordmark) return <ApertureMark size={size} className={className} />;

  return (
    <span className={`logo ${className}`}>
      <ApertureMark size={size} className="logo-mark" />
      <span className="logo-wordmark" style={{ fontSize: `${size * 0.9}px` }}>
        Kévin <em>Gelineau</em>
      </span>
    </span>
  );
}
